import { render, staticRenderFns } from "./workOrderTransfer.vue?vue&type=template&id=64eff2fa&"
import script from "./workOrderTransfer.vue?vue&type=script&lang=js&"
export * from "./workOrderTransfer.vue?vue&type=script&lang=js&"
import style0 from "./workOrderTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports